import { render, staticRenderFns } from "./PortcallclearancesstatusGrid.vue?vue&type=template&id=2801c848"
import script from "./PortcallclearancesstatusGrid.vue?vue&type=script&lang=js"
export * from "./PortcallclearancesstatusGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports